import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface ExportacaoCardapio {
    conteudo: string
    nomeArquivo: string
}

export interface ImportacaoCardapioResultado {
    mensagem: string
    idCardapio: number
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

export type SeparadorExportacao = "ponto-virgula" | "tab"

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (isErroBackend(data)) {
        return { codErro: data.codErro, mensagem: data.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const exportarCardapio = async function (
    authorization: string,
    idEstabelecimento: number,
    separador: SeparadorExportacao,
    agrupamento: boolean
): Promise<ExportacaoCardapio | ErroApi> {
    try {
        const response = await api
            .get<ExportacaoCardapio | RespostaErroRaw>(`cardapio/exportar/${idEstabelecimento}`, {
                params: {
                    separador: separador === "tab" ? "tab" : "ponto-virgula",
                    agrupamento,
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authorization,
                },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        return response.data as ExportacaoCardapio
    } catch (error) {
        RegistrarLogErro(error, "exportarCardapio", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const importarCardapio = async function (
    authorization: string,
    idEstabelecimento: number,
    conteudo: string,
    fotosEmPng: boolean
): Promise<ImportacaoCardapioResultado | ErroApi> {
    try {
        const response = await api
            .post<ImportacaoCardapioResultado | RespostaErroRaw>(
                `cardapio/importar/${idEstabelecimento}`,
                { conteudo, fotosEmPng },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authorization,
                    },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        return response.data as ImportacaoCardapioResultado
    } catch (error) {
        RegistrarLogErro(error, "importarCardapio", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
